import { fanUsersCheckBanStatus } from '@zealot/shared/apiClient';
import { type Client } from '@zealot/shared/apiClient/client';

// gloss
export class FanUserBannedError extends Error {
  constructor() {
    super('This account has been banned.');
    this.name = 'FanUserBannedError';
  }
}

// gloss
// why: must fail open here and let findOrCreateGuest re-check: a banned user's Auth0 identity
// why: still works normally.
export const assertFanUserNotBanned = async (client: Client, email: string): Promise<void> => {
  const banCheck = await fanUsersCheckBanStatus({ client, body: { email } });
  if (banCheck.response?.status === 403) {
    throw new FanUserBannedError();
  }
};
